import React, { Component } from 'react'
import { MaskedTextField, TextField } from '@fluentui/react';
import { connect } from 'react-redux';
import { updateStepValidationStatus } from '../../actions/ValidationActions/clientValidation';
import Warning from "../CreateSite/CommonComponents/Warning";
class RequiredTextField extends Component {

    componentDidMount() {
        this.props.updateStepValidationStatus(this.props.name, this.isValid());
    }

    componentDidUpdate() {
        this.props.updateStepValidationStatus(this.props.name, this.isValid());
    }

    componentWillUnmount() {
        this.props.updateStepValidationStatus(this.props.name, true);
    }

    isEmpty() {
        return !this.props.notRequired && !this.props.value
    }

    isValid() {
        return !this.isEmpty() && (!this.props.validationResult || this.props.validationResult.isValid)
    }

    render() {
        let error = null;
        if (this.props.possibleWarning && this.isEmpty()) {
            error = `${this.props.name} cannot be empty.`;
        }
        else if (this.props.validationResult && !this.props.validationResult.isValid && (this.props.possibleWarning || !this.props.validationResult.hideIfNotNeeded)) {
            error = Array.isArray(this.props.validationResult.message) 
                    ? this.props.validationResult.message.map((msg, index) => <span key={index}>{msg}<br /></span>)
                    : this.props.validationResult.message;
        }

        const warning = this.props.possibleWarning && !this.isValid()
            ? <Warning element={`${!this.props.label ? 'withLabel' : 'nolabel-small'}`} />
            : null;

        const styles = {
            wrapper: {
                display: this.props.inline ? 'flex' : 'block',
                justifyContent: 'space-between'
            },
            fieldGroup: {
                width: this.props.width || 'auto'
            }
        }

        const textFieldProps = {
            label: this.props.label || "Required",
            required: !this.props.notRequired,
            autoComplete: "off",
            type: "text",
            invalid: !!error,
            errorMessage: !this.props.hideError && error,
            disabled: this.props.isPickerDisabled,
            styles: styles,
            ...this.props
        }

        return (
            <div>
                {warning}
                {
                    this.props.mask
                    ? <MaskedTextField
                        {...textFieldProps}
                     />
                    : <TextField
                        {...textFieldProps}
                     />
                }
            </div>
        )
    }
}


const mapActionToProp = {
    updateStepValidationStatus
}

const mapStateToProps = state => ({
    possibleWarning: state.wizard.nextStepRequested
})

export default connect(mapStateToProps, mapActionToProp)(RequiredTextField);



// WEBPACK FOOTER //
// ./src/components/formFields/RequiredTextField.js